import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";

interface Props {
  activity: server.dto.UserTaskTemplateActivity
}

export const DefaultTaskActivityCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
  </ActivityCard>
}